import { deepCloneObject } from "@thekilroygroup/shared-ui";
import { IFlight } from "redux/searchForm";

export const validateSearchForm = (flights: IFlight[]) => {
  let isValid = true;

  let nextFlights: IFlight[] = deepCloneObject(flights);

  nextFlights.forEach((flight: IFlight) => {
    flight.validation.arrival = {
      dirty: true,
      valid: flight.arrival !== null && flight.arrival.length === 3,
    };
    flight.validation.departure = {
      dirty: true,
      valid: flight.departure !== null && flight.departure.length === 3,
    };
    flight.validation.departureDate = {
      dirty: true,
      valid: flight.departureDate !== null,
    };
    if (
      flight.arrival === null ||
      flight.arrival.length !== 3 ||
      flight.departure === null ||
      flight.departure.length !== 3 ||
      flight.departureDate === null
    ) {
      isValid = false;
    }
  });

  return {
    nextFlights: nextFlights,
    isValid: isValid,
  };
};
